module.exports = __webpack_public_path__ + "static/livit-pill-bottle-750ccc033f7ea0fbdc21ded5a80f8b61.jpg";